import Vue from 'vue'
import mutationTypes from '../mutation-type'

export default {
  state: {
    // 组卷选中的题目
    selectedItems: [],
    itemsStatus: []
  },
  actions: {
  },
  mutations: {
    // 组卷 新增选中的试题
    [mutationTypes.ADD_SELECTED_ITEM] (state, payload) {
      state.selectedItems.push(payload.item)
    },
    // 组卷 新增选中的试题,按id删除
    [mutationTypes.REMOVE_SELECTED_ITEM] (state, payload) {
      let id = payload.id
      let itemIndex = state.selectedItems.findIndex((item, index) => {
        return item.id === id
      })
      state.selectedItems.splice(itemIndex, 1)
    },

    // 组卷 清空选中的试题
    [mutationTypes.CLEAR_SELECTED_ITEM] (state) {
      state.selectedItems.splice(0, state.selectedItems.length)
    },
    // 组卷 清空选中的试题状态
    [mutationTypes.CLEAR_ITEM_STATUS] (state) {
      state.itemsStatus.splice(0, state.itemsStatus.length)
    },
    // 填充已选择的题目到内存
    [mutationTypes.RECOVER_SELECTED_ITEMS] (state, payload) {
      state.selectedItems.splice(0, state.selectedItems.length)
      for (let item of payload.selectedItems) {
        item.score = parseFloat(item.score)
        state.selectedItems.push(item)
      }
    },
    // 组卷 新增选中的试题状态
    [mutationTypes.ADD_ITEM_STATE] (state, payload) {
      let itemStateIndex = state.itemsStatus.findIndex((itemState, index) => {
        return payload.itemState.id === itemState.id
      })
      if (itemStateIndex === -1) {
        state.itemsStatus.push(payload.itemState)
      }
    },

    // 组卷 新增选中的试题状态对象
    [mutationTypes.SET_ITEM_STATE_SELECT] (state, payload) {
      let id = payload.id
      let isSelected = payload.isSelected
      for (let itemState of state.itemsStatus) {
        if (itemState.id === id) {
          itemState.isSelected = isSelected
        }
      }
    },

    // 初始化试题分数,按照题型排序-升序
    [mutationTypes.INIT_ITEM_SORT] (state, payload = {score: 0}) {
      // for (let item of state.selectedItems) {
      //   Vue.set(item, 'score', payload.score)
      // }
      state.selectedItems.sort(function (a, b) {
        return parseInt(a.questionType) - parseInt(b.questionType)
      })
    },
    // 修改题目分数
    [mutationTypes.SET_ITEM_SCORE] (state, payload = {itemId: 0, score: 0}) {
      let itemIndex = state.selectedItems.findIndex((item, index) => {
        return payload.itemId === item.id
      })
      console.log(itemIndex)
      if (itemIndex !== -1) {
        state.selectedItems[itemIndex].score = payload.score
      }
    },
    // 修改题目排序
    [mutationTypes.SET_ITEM_SORT] (state, payload = {items: [], itemType: 0}) {
      let itemIndex = state.selectedItems.findIndex((item, index) => {
        return payload.itemType === item.questionType
      })
      let length = payload.items.length
      state.selectedItems.splice(itemIndex, length, ...payload.items)
    },
    // 同步题目分数
    [mutationTypes.SYNC_ITEM_SCORE] (state, payload = []) {
      for (let scoringItem of payload) {
        for (let item of state.selectedItems) {
          if (scoringItem.id === item.id) {
            if (parseFloat(scoringItem.score) !== parseFloat(item.score)) {
              item.score = scoringItem.score
            }
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/paper.js